<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="school_class" slot-scope="school_class">
          <div>
            <div class="font-weight-bold">{{school_class.name}}</div>
          </div>
        </template>
        <template slot="session" slot-scope="session">
          <div class="font-weight-bold">{{session.name}}</div>
        </template>
        <template slot="start_date" slot-scope="start_date">
          <span class="text-success">{{moment(start_date).format(dateFormat)}}</span>
        </template>
        <template slot="end_date" slot-scope="end_date">
          <span class="text-danger">{{moment(end_date).format(dateFormat)}}</span>
        </template>
        <template slot="application_fee" slot-scope="application_fee">
          <span class="font-weight-bold">{{application_fee}}</span>
        </template>
        <template slot="payment_mode" slot-scope="payment_mode">
          <span>{{getPaymentMode(payment_mode)}}</span>
        </template>
        <template slot="online_admission" slot-scope="online_admission">
          <span>{{online_admission !== 0 ? 'Yes' : 'No'}}</span>
        </template>
        <template slot="admission_last_date" slot-scope="admission_last_date">
          <span class="font-weight-bold">{{moment(admission_last_date).format(dateFormat)}}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Manage -->
            <a href="javascript:;" class="btn btn-sm btn-primary btn-with-addon mr-2"
              @click="handleManageForm(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-grid" />
              </span>
              <!-- <edit-board ref="editBoard" @edited="handleEdited"/> -->
              Manage
            </a>
            <!-- Edit -->
            <a href="javascript:;" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <!-- <edit-board ref="editBoard" @edited="handleEdited"/> -->
              Edit
            </a>
            <!-- Delete -->
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
              @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </div>

    <edit-application-form ref="editBoard" @edited="handleEdited"/>
  </div>
</template>
<script>
import moment from 'moment'
import { find } from 'lodash'

import { onlineApplicationPaymentModes } from '@/services/globaldata.js'

import EditApplicationForm from '@/components/applicationform/Forms/Edit/index'

const columns = [
  {
    title: 'Class',
    dataIndex: 'school_class',
    scopedSlots: { customRender: 'school_class' },
  },
  {
    title: 'Session',
    dataIndex: 'session',
    scopedSlots: { customRender: 'session' },
  },
  {
    title: 'Start Date',
    dataIndex: 'start_date',
    scopedSlots: { customRender: 'start_date' },
  },
  {
    title: 'End Date',
    dataIndex: 'end_date',
    scopedSlots: { customRender: 'end_date' },
  },
  {
    title: 'Fee',
    dataIndex: 'application_fee',
    scopedSlots: { customRender: 'application_fee' },
  },
  {
    title: 'Payment Mode',
    dataIndex: 'payment_mode',
    scopedSlots: { customRender: 'payment_mode' },
  },
  {
    title: 'Online Admission',
    dataIndex: 'online_admission',
    scopedSlots: { customRender: 'online_admission' },
  },
  {
    title: 'Admission Last Date',
    dataIndex: 'admission_last_date',
    scopedSlots: { customRender: 'admission_last_date' },
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'ApplicationFormTable',
  components: {
    EditApplicationForm,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      onlineApplicationPaymentModes,
      columns,
      selectedRowKeys: [],
      dateFormat: 'DD-MM-YYYY',
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    moment,
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      this.$eventBus.$emit('openApplicationFormEditModal', record.id)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    handleManageForm(record) {
      this.$router.push({ name: 'applicants', params: { formId: record.id } })
    },
    getPaymentMode(value) {
      let paymentMode = find(this.onlineApplicationPaymentModes, { 'value': value })
      if (paymentMode) {
        return paymentMode.name
      } else {
        return ''
      }
    },
    onDelete: function(record) {
      if (record.applicants_count !== 0) {
        this.$message.error('Form has applicants already signed up! You cannot delete this form.')
      } else {
        this.$confirm({
          title: 'Are you sure?',
          content: 'Click OK to delete this application form.',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk: () => {
            this.$nprogress.start()
            this.$http
              .delete('/api/online-application/' + record.id)
              .then(() => {
                this.$emit('updateTable')
                this.$nprogress.done()
                this.$notification['success']({
                  message: 'Deleted Successfully!',
                  description: 'Application form has been deleted.',
                })
              })
              .catch(error => {
                this.$nprogress.done()
                this.$neoNotify.error(error)
              })
          },
          onCancel: () => {
            console.log('Cancel')
          },
        })
      }
    },
  },
}
</script>
